var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { resolve } from '@cvent/nucleus-dynamic-css';
import Countdown from 'nucleus-core/counters/Countdown.js';
import { resolveTestId } from '@cvent/nucleus-test-automation';
/**
* The CountdownTimer widget.
*/
var CountdownTimer = function (props) {
    return React.createElement("div", __assign({}, resolveTestId(props), resolve(props, 'container')),
        React.createElement(Countdown, __assign({}, props)));
};
CountdownTimer.displayName = 'CountdownTimer';
export default CountdownTimer;
